// extracted by mini-css-extract-plugin
export default {"container":"InviteInfo_container__nYD5O","footer":"InviteInfo_footer__BLLeZ","button":"InviteInfo_button__wPprY","button-back":"InviteInfo_button-back__m6euE"};